import { Base } from "../../../../../base/components/base"
import { Div } from "../../../../../base/components/native/div"
import services from "../../../../../services"
import { Tab } from "../tab"
import { chartContainerStyle, gridStyle, headerStyle, rowStyle } from "./analytics.style"
import { AnalyticsChart } from "./analytics-chart"
import { dateRangeOptions, DateRange, getDateRangeDays } from "./jalaali-utils"
import { JalaaliDatePicker } from "./jalaali-date-picker"

export const AnalyticsTab = () => {
    const base = Tab('analytics')

    const container = Div()
    container.style({
        padding: '20px',
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
    })
    base.append(container)

    // Chart on top (50%)
    const chartContainer = Div()
    chartContainer.style(chartContainerStyle)
    container.append(chartContainer)

    const chart = AnalyticsChart()
    chartContainer.append(chart)

    // Date range selector bar
    const dateRangeBar = Div()
    dateRangeBar.style({
        display: 'flex',
        gap: '10px',
        marginBottom: '10px',
        direction: 'rtl',
        alignItems: 'center',
        flexWrap: 'wrap'
    })
    container.append(dateRangeBar)

    let currentDateRange: DateRange = 'lastMonth'
    const dateRangeButtons: HTMLButtonElement[] = []

    // Create date range buttons
    dateRangeOptions.forEach(option => {
        const btn = document.createElement('button')
        btn.innerText = option.label
        btn.style.padding = '5px 15px'
        btn.style.border = '1px solid #ccc'
        btn.style.borderRadius = '4px'
        btn.style.cursor = 'pointer'
        btn.style.backgroundColor = option.id === 'lastMonth' ? '#28a745' : 'white'
        btn.style.color = option.id === 'lastMonth' ? 'white' : 'black'

        btn.addEventListener('click', () => {
            if (option.id === 'custom') {
                // Show date pickers
                customDateContainer.style.display = 'flex'
            } else {
                customDateContainer.style.display = 'none'
                currentDateRange = option.id
                updateDateRangeButtonStyles()
                reloadCurrentItem()
            }
        })

        dateRangeButtons.push(btn)
        dateRangeBar.el.appendChild(btn)
    })

    // Custom date picker container
    const customDateContainer = document.createElement('div')
    customDateContainer.style.display = 'none'
    customDateContainer.style.gap = '10px'
    customDateContainer.style.alignItems = 'center'
    customDateContainer.style.marginRight = '10px'
    dateRangeBar.el.appendChild(customDateContainer)

    // From date picker (Jalaali)
    const fromLabel = document.createElement('span')
    fromLabel.innerText = 'از:'
    fromLabel.style.fontSize = '14px'
    customDateContainer.appendChild(fromLabel)

    let fromDate: Date | null = null
    let toDate: Date | null = null

    const fromPicker = JalaaliDatePicker({
        onSelect: (date) => { fromDate = date }
    })
    customDateContainer.appendChild(fromPicker.el)

    // To date picker (Jalaali)
    const toLabel = document.createElement('span')
    toLabel.innerText = 'تا:'
    toLabel.style.fontSize = '14px'
    customDateContainer.appendChild(toLabel)

    const toPicker = JalaaliDatePicker({
        onSelect: (date) => { toDate = date }
    })
    customDateContainer.appendChild(toPicker.el)

    // Apply button
    const applyBtn = document.createElement('button')
    applyBtn.innerText = 'اعمال'
    applyBtn.style.padding = '5px 15px'
    applyBtn.style.border = '1px solid #28a745'
    applyBtn.style.borderRadius = '4px'
    applyBtn.style.cursor = 'pointer'
    applyBtn.style.backgroundColor = '#28a745'
    applyBtn.style.color = 'white'
    applyBtn.addEventListener('click', () => {
        if (fromDate && toDate) {
            const diffDays = Math.ceil((toDate.getTime() - fromDate.getTime()) / (1000 * 60 * 60 * 24)) + 1
            if (diffDays > 0) {
                currentDateRange = 'custom'
                updateDateRangeButtonStyles()
                reloadCurrentItem(diffDays)
            }
        }
    })
    customDateContainer.appendChild(applyBtn)

    function updateDateRangeButtonStyles() {
        dateRangeOptions.forEach((option, index) => {
            const btn = dateRangeButtons[index]
            if (option.id === currentDateRange) {
                btn.style.backgroundColor = '#28a745'
                btn.style.color = 'white'
            } else {
                btn.style.backgroundColor = 'white'
                btn.style.color = 'black'
            }
        })
    }

    // Filter bar
    const filterBar = Div()
    filterBar.style({
        display: 'flex',
        gap: '10px',
        marginBottom: '10px',
        direction: 'rtl'
    })
    container.append(filterBar)

    const filterTypes = ['all', 'article', 'video', 'video-play']
    const filterLabels: Record<string, string> = {
        'all': 'همه',
        'article': 'مقالات',
        'video': 'ویدیوها',
        'video-play': 'ویدیوپلی',
    }

    let currentFilter = 'all'
    const filterButtons: HTMLButtonElement[] = []

    filterTypes.forEach(type => {
        const btn = document.createElement('button')
        btn.innerText = filterLabels[type] || type
        btn.style.padding = '5px 15px'
        btn.style.border = '1px solid #ccc'
        btn.style.borderRadius = '4px'
        btn.style.cursor = 'pointer'
        btn.style.backgroundColor = type === 'all' ? '#007bff' : 'white'
        btn.style.color = type === 'all' ? 'white' : 'black'

        btn.addEventListener('click', () => {
            currentFilter = type
            filterButtons.forEach(b => {
                b.style.backgroundColor = 'white'
                b.style.color = 'black'
            })
            btn.style.backgroundColor = '#007bff'
            btn.style.color = 'white'
            renderItems()
        })

        filterButtons.push(btn)
        filterBar.el.appendChild(btn)
    })

    // Grid Header
    const header = Div()
    header.cssClass(gridStyle)
    header.style(headerStyle)
    header.el.innerHTML = `
        <div>عنوان</div>
        <div id="header-total" style="cursor:pointer">بازدید کل <span id="icon-total">▼</span></div>
        <div id="header-24h" style="cursor:pointer">۲۴ ساعت <span id="icon-24h"></span></div>
        <div id="header-week" style="cursor:pointer">هفته <span id="icon-week"></span></div>
        <div id="header-month" style="cursor:pointer">ماه <span id="icon-month"></span></div>
        <div id="header-type" style="cursor:pointer">نوع <span id="icon-type"></span></div>
    `
    container.append(header)

    // Grid (scrollable, takes remaining space)
    const gridContainer = Div()
    gridContainer.style({ overflowY: 'auto', minHeight: '0', height: 'calc(100vh - 530px)' })
    container.append(gridContainer)

    let items: any[] = []
    let sortField: 'total_views' | 'views_24h' | 'views_week' | 'views_month' | 'content_type' = 'total_views'
    let sortDesc = true
    let selectedItem: any = null

    // Click on header to sort
    const totalViewsHeader = header.el.querySelector('#header-total') as HTMLElement
    const views24hHeader = header.el.querySelector('#header-24h') as HTMLElement
    const viewsWeekHeader = header.el.querySelector('#header-week') as HTMLElement
    const viewsMonthHeader = header.el.querySelector('#header-month') as HTMLElement
    const typeHeader = header.el.querySelector('#header-type') as HTMLElement
    const iconTotal = header.el.querySelector('#icon-total') as HTMLElement
    const icon24h = header.el.querySelector('#icon-24h') as HTMLElement
    const iconWeek = header.el.querySelector('#icon-week') as HTMLElement
    const iconMonth = header.el.querySelector('#icon-month') as HTMLElement
    const iconType = header.el.querySelector('#icon-type') as HTMLElement

    totalViewsHeader.addEventListener('click', () => setSort('total_views'))
    views24hHeader.addEventListener('click', () => setSort('views_24h'))
    viewsWeekHeader.addEventListener('click', () => setSort('views_week'))
    viewsMonthHeader.addEventListener('click', () => setSort('views_month'))
    typeHeader.addEventListener('click', () => setSort('content_type'))

    function setSort(field: 'total_views' | 'views_24h' | 'views_week' | 'views_month' | 'content_type') {
        if (sortField === field) {
            sortDesc = !sortDesc
        } else {
            sortField = field
            sortDesc = true
        }

        // Update icons
        if (iconTotal) iconTotal.innerText = ''
        if (icon24h) icon24h.innerText = ''
        if (iconWeek) iconWeek.innerText = ''
        if (iconMonth) iconMonth.innerText = ''
        if (iconType) iconType.innerText = ''

        const arrow = sortDesc ? '▼' : '▲'
        if (field === 'total_views' && iconTotal) iconTotal.innerText = arrow
        if (field === 'views_24h' && icon24h) icon24h.innerText = arrow
        if (field === 'views_week' && iconWeek) iconWeek.innerText = arrow
        if (field === 'views_month' && iconMonth) iconMonth.innerText = arrow
        if (field === 'content_type' && iconType) iconType.innerText = arrow

        renderItems()
    }

    function renderItems() {
        gridContainer.el.innerHTML = ''

        // Filter
        let filtered = items
        if (currentFilter !== 'all') {
            filtered = items.filter(item => item.content_type === currentFilter)
        }

        // Sort
        const sorted = [...filtered].sort((a, b) => {
            const v1 = a[sortField]
            const v2 = b[sortField]
            if (typeof v1 === 'string') {
                return sortDesc ? v2.localeCompare(v1) : v1.localeCompare(v2)
            }
            return sortDesc ? v2 - v1 : v1 - v2
        })

        sorted.forEach(item => {
            const row = Div()
            row.cssClass(gridStyle)
            row.style(rowStyle)
            row.el.dataset.id = item._id

            row.el.innerHTML = `
                <div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;" title="${item.title}">${item.title || item.url}</div>
                <div>${item.total_views}</div>
                <div>${item.views_24h || 0}</div>
                <div>${item.views_week || 0}</div>
                <div>${item.views_month || 0}</div>
                <div>${item.content_type}</div>
            `

            row.el.addEventListener('click', () => {
                selectItem(item, row)
            })

            gridContainer.append(row)
        })
    }

    function selectItem(item: any, row?: any) {
        selectedItem = item
        const days = getDateRangeDays(currentDateRange) || 30
        // _id is now a composite "<content_id>__<content_type>"; the chart queries
        // views-by-date per content_id (combines page-views and plays in one timeline).
        chart.load(item.content_id || item._id, item.title || item.url, days)

        // Highlight selected
        Array.from(gridContainer.el.children).forEach((c: any) => c.style.backgroundColor = '')

        if (row) {
            row.el.style.backgroundColor = '#e0f7fa'
        } else {
            const targetRow = Array.from(gridContainer.el.children).find((c: any) => c.dataset.id === item._id) as HTMLElement
            if (targetRow) targetRow.style.backgroundColor = '#e0f7fa'
        }
    }

    function reloadCurrentItem(customDays?: number) {
        if (selectedItem) {
            const days = customDays || getDateRangeDays(currentDateRange) || 30
            chart.load(selectedItem.content_id || selectedItem._id, selectedItem.title || selectedItem.url, days)
        }
    }

    // Override show to fetch data
    const originalShow = base.show
    base.show = async () => {
        originalShow()
        try {
            items = await services.api.request('/api/analytics/overview')
            renderItems()

            // Auto select first item
            if (items.length > 0) {
                const sorted = [...items].sort((a, b) => {
                    const v1 = a[sortField]
                    const v2 = b[sortField]
                    return sortDesc ? v2 - v1 : v1 - v2
                })
                selectItem(sorted[0])
            }

        } catch (error) {
            console.error(error)
        }
    }

    return base
}
